import { useTranslation } from "react-i18next";

export default function FeaturesSection() {
  const { t } = useTranslation();

  const features = [
    {
      icon: "ri-heart-pulse-line",
      title: t("feature1_title"),
      desc: t("feature1_desc"),
      color: "bg-orange-100 text-orange-600"
    },
    {
      icon: "ri-group-line",
      title: t("feature2_title"),
      desc: t("feature2_desc"),
      color: "bg-pink-100 text-pink-600"
    },
    {
      icon: "ri-star-smile-line",
      title: t("feature3_title"),
      desc: t("feature3_desc"),
      color: "bg-yellow-100 text-yellow-600"
    },
    {
      icon: "ri-global-line",
      title: t("feature4_title"),
      desc: t("feature4_desc"),
      color: "bg-blue-100 text-blue-600"
    },
    {
      icon: "ri-trophy-line",
      title: t("feature5_title"),
      desc: t("feature5_desc"),
      color: "bg-green-100 text-green-600"
    }
  ];

  const highlights = [
    {
      icon: "ri-speak-line",
      title: t("highlight1_title"),
      desc: t("highlight1_desc")
    },
    {
      icon: "ri-user-star-line",
      title: t("highlight2_title"),
      desc: t("highlight2_desc")
    },
    {
      icon: "ri-body-scan-line",
      title: t("highlight3_title"),
      desc: t("highlight3_desc")
    },
    {
      icon: "ri-emotion-happy-line",
      title: t("highlight4_title"),
      desc: t("highlight4_desc")
    }
  ];

  return (
    <section id="features" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="text-4xl sm:text-5xl font-bold text-center text-gray-900 mb-16">
          {t("features_title")}
        </h2>
        
        {/* Lesson Highlights */}
        <div className="mb-20">
          <h3 className="text-3xl font-bold text-center text-gray-900 mb-12">
            {t("lesson_highlights_title")}
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-12">
            {highlights.map((highlight, index) => (
              <div
                key={index}
                className="bg-gradient-to-br from-teal-50 to-white rounded-xl p-6 shadow-md hover:shadow-lg transition-all duration-300 border border-teal-100"
              >
                <div className="w-14 h-14 bg-teal-100 rounded-full flex items-center justify-center mb-4 mx-auto">
                  <i className={`${highlight.icon} text-2xl text-teal-600`}></i>
                </div>
                <h4 className="text-lg font-bold text-gray-900 mb-2 text-center">{highlight.title}</h4>
                <p className="text-gray-600 text-sm text-center leading-relaxed text-justify">{highlight.desc}</p>
              </div>
            ))}
          </div>
        </div>

        <div className="mb-16">
          <div className="w-full h-[500px] rounded-2xl overflow-hidden shadow-xl">
            <img 
              src="https://static.readdy.ai/image/2ea0b8c267a34173059ce081fb680942/fd99ba5d43b40910024e9d2c4d6c995e.jpeg"
              alt="J-Motion Kids features"
              className="w-full h-full object-cover object-top"
            />
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <div
              key={index}
              className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-all duration-300 border border-gray-100 hover:border-teal-200"
            >
              <div className={`w-16 h-16 ${feature.color} rounded-xl flex items-center justify-center mb-6`}>
                <i className={`${feature.icon} text-3xl`}></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">{feature.title}</h3>
              <p className="text-gray-600 leading-relaxed text-justify">{feature.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
